import { defineMessages } from 'react-intl';

export default defineMessages({
    contactPerson: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.injuredPerson',
        defaultMessage: 'Person'
    },
    addNewPerson: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.addNewPerson',
        defaultMessage: 'Add new person'
    },
    injuredPersonFirstName: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.PedestrianFirstName',
        defaultMessage: 'Pedestrian First Name'
    },
    injuredPersonLastName: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.PedestrianLastName',
        defaultMessage: 'Pedestrian Last Name'
    },
    cancel: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.save',
        defaultMessage: 'Save & Close'
    },
    unknowTips: {
        id: 'wni.fnol.pa.views.incidentdetails.singlePedestrianPopup.unknowTips',
        defaultMessage: 'If you don\'t know specific {what}, please enter \'Unknown\''
    }
})